import { render, staticRenderFns } from "./SiopAcademyHomepage.vue?vue&type=template&id=7726194a&scoped=true"
import script from "./SiopAcademyHomepage.vue?vue&type=script&lang=js"
export * from "./SiopAcademyHomepage.vue?vue&type=script&lang=js"
import style0 from "./SiopAcademyHomepage.vue?vue&type=style&index=0&id=7726194a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7726194a",
  null
  
)

export default component.exports